module.exports = __webpack_public_path__ + "static/media/img1-3.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/nutricheck_foliar/K/img1-3.png
// module id = 1480
// module chunks = 3